module.exports = __webpack_public_path__ + "static/media/email-dark.949afb96.svg";